import { render, staticRenderFns } from "./upload-attach.vue?vue&type=template&id=047c0bb4&scoped=true"
import script from "./upload-attach.vue?vue&type=script&lang=js"
export * from "./upload-attach.vue?vue&type=script&lang=js"
import style0 from "./upload-attach.vue?vue&type=style&index=0&id=047c0bb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c0bb4",
  null
  
)

export default component.exports